module.exports = __webpack_public_path__ + "img/47.zone_is_dirty.5813071c.svg";